module.exports = __webpack_public_path__ + "img/背景.1f964ffa.png";